function getFilledPersonOwnIds(wplyw) {
    // List of required fields with second parameter indicating if the field can be 0
    const requiredFields = [
        ["msr_persons_amount", true],  // Cannot be 0
        ["msr_persons_deduction", true], // Can be 0
        ["msr_persons_lastname", false], // Cannot be empty
        ["msr_persons_name", false]     // Cannot be empty
    ];

    // Extract the persons array from the wplyw object
    const persons = wplyw?.wplyw_data?.data?.msr_wplywy?.msr_persons || [];

    // Filter persons with all required fields filled
    const filledPersonOwnIds = persons
        .filter(person => {
            return requiredFields.every(([field, canBeZero]) => {
                const value = person[field];
                if(field == 'msr_persons_amount'){
                    // If the field can be zero, check that it's not null or undefined
                    if (wplyw?.wplyw_data?.data?.msr_wplywy?.msr_wplywy_primary_amount - wplyw?.wplyw_data?.data?.msr_wplywy?.msr_wplywy_primary_deduction == 0) {
                        return value !== undefined && value !== null && value !== '';
                    }
                    // For fields that cannot be zero, check that the value is truthy (not null, undefined, or 0)
                    return value !== undefined && value !== null && value !== 0 && value !== '';
                } else {
                    // If the field can be zero, check that it's not null or undefined
                    if (canBeZero) {
                        return value !== undefined && value !== null && value !== '';
                    }
                    
                    // For fields that cannot be zero, check that the value is truthy (not null, undefined, or 0)
                    return value !== undefined && value !== null && value !== 0 && value !== '';
                }
            });
        })
        .map(person => person.msr_persons_own_id); // Map to own_id

    return filledPersonOwnIds;
}

export default getFilledPersonOwnIds;
